<template>
	<div class="d-account l">
		<div v-show="FenXiao">
					<div class="top"><p class="l">分销账户</p><p class="r" @click="shenQing">申请提现</p></div>
					<ul>
						<li>可提现金额：<span> 900.00</span>元</li><li>今日收入：<span> 900.00</span>元</li><li>总销售额度：<span> 900.00</span>元</li><li>累计获得佣金：<span> 900.00</span>元</li>
					</ul></div>
					<div class="inner" v-show="FenXiaos">
						<div class="top"><p>绑定提现账号</p></div>
						<div class="spa">
							<p><span>*</span>请输入您要提现的金额:<input type="text" /><span><img src="../../../assets/img/weixian.png"/> 请输入您要提现的金额不能为空</span></p>
							<p class="huise">提现金额必须大于0，不得大于您的可提现资金</p>
						</div>
						<div class="spa">
							<p><span>*</span>请输入您要提现的账户:<select name=""><option value="">中国建设银行     尾号0895</option></select><span class="lanse" >绑定提现账户</span></p>
							<p class="huise">提现，需要绑定您的银行卡或者支付宝等账户，网站方会将提现金额打入您绑定的提现账户中</p>
						</div>
						<div class="submit">提交申请</div>
					</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
      FenXiao:true,FenXiaos:false
    }
  },
  created () {
  },
  methods: {
   	shenQing(){
		this.FenXiao=false
		this.FenXiaos=true
	}
  }
}
</script>

<style lang="less" scoped>
	.l{float: left;}
	.r{float: right;}
	.center {width: 1200px;margin: 0 auto;height: 100%;}
	.d-account{
			width:980px;background: #fff;margin:16px 0;height:550px;
			.top{overflow: hidden; margin:14px 17px 0px;border-bottom:1px solid #e7e7e7;line-height:37px;p.l{width:104px;text-align: center;border-bottom:2px solid #d19e29;font-size:14px;color:#d19e29;}p.r{width:80px;height:28px;background:#ffaa45;text-align: center;line-height:28px;margin-top:5px;border-radius:4px;color:#fff;cursor:pointer;}}
			ul{
				margin:11px 17px 0;
				li{line-height:55px;margin-bottom:1px;font-size:12px;color:#7a7973;background:#f6f6f6;span{color:#e31939;font-weight:600;}}
				li:nth-of-type(1){padding-left:32px;background:#fffdee;}li:nth-of-type(2){padding-left:42px;}li:nth-of-type(3){padding-left:32px;}li:nth-of-type(4){padding-left:20px;}
			}
			.inner{
				.top{overflow: hidden; margin:14px 17px 0px;border-bottom:1px solid #e7e7e7;line-height:37px;p{width:104px;text-align: center;border-bottom:2px solid #d19e29;font-size:12px;color:#d19e29;}}
				.spa{ margin:30px 17px 0px;span{color:#ff2424;margin-right:7px;}input{width:150px;height:30px;border:1px solid #ccc;margin:0 12px 0 10px;}img{display:inline-block;margin-top:-3px;}
					.huise{font-size:12px;color:#999;margin:7px 0 0 165px;}select{width:268px;height:30px;outline:none;color:#999;margin:0 12px 0 10px;}.lanse{color: #427ab4;cursor:pointer;}
				}
				.submit{width:94px;height:32px;text-align: center;background:#d19e29;color:#fff;line-height:32px;font-size:12px;margin:33px 0 0 180px;cursor:pointer;border-radius:3px;}
			}
		}
</style>